import { ValidableField } from './ValidableField';
import { ChangeEvent } from 'react';
import { Select } from '@apia/theme';
import { makeValidableField } from './makeValidableField';
import { getLabel } from '@apia/util';

export const ValidableSelect = makeValidableField<{
  options: {
    value: string;
    label: string;
    selected?: boolean;
    disabled?: boolean;
  }[];
}>(({ context, label, path, onChange, options, ...props }) => {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    context.setValue(path, event.target.value);
    onChange?.(event);
  };

  return (
    <ValidableField
      context={context}
      path={path as never}
      label={label}
      {...props}
      className={`select ${props.className}`}
    >
      <Select
        name={path}
        value={context.getValue(path)}
        onChange={handleChange}
      >
        {options.map((option) => (
          <option
            selected={option.selected}
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label.startsWith('lbl')
              ? getLabel(option.label).text
              : option.label}
          </option>
        ))}
      </Select>
    </ValidableField>
  );
});
